import { render } from "./AddLessonUnit.vue?vue&type=template&id=057cdfc4&scoped=true"
import script from "./AddLessonUnit.vue?vue&type=script&lang=js"
export * from "./AddLessonUnit.vue?vue&type=script&lang=js"

import "./AddLessonUnit.vue?vue&type=style&index=0&id=057cdfc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057cdfc4"]])

export default __exports__